<div class="twc-m-2">
    <h1 class="twc-h1">{{ 'WIZARD.TAB_NEW_PROJECT' | translate }}</h1>

    <form [formGroup]="uploadWizardService.projectForm">
        <div class="twc-form twc-mt-4">
            <div>
                <label class="twc-form-label twc-body-bold">
                    <b>{{label | translate}}</b>
                </label>
                <div class="twc-form-element"
                    [ngClass]="{'twc-invalid': this.uploadWizardService.projectForm.get('projectName')?.errors}">
                    <input class="twc-input width-100" name="projectName" formControlName="projectName"
                        [maxlength]="uploadWizardService.nameProjectMaxLength">

                </div>
                <div class="twc-mt-2">
                    <div class="twc-form-error twc-d-block"
                        *ngIf="this.uploadWizardService.projectForm.get('projectName')?.hasError('required')">
                        {{'UPLOAD.NAME_REQUIRED' | translate}}
                    </div>

                    <div *ngIf="this.uploadWizardService.projectForm.get('projectName')?.hasError('pattern')"
                        class="twc-form-error twc-d-block">
                        {{'UPLOAD.NAME_CORRECT' | translate}}
                    </div>
                </div>
            </div>
            <div *ngIf="hasToShowCaptureDate" class="twc-form-control twc-col-lg-6 twc-col-md-12 twc-pl-0 twc-mt-3">
                <label for="captureDate" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.CAPTURE_DATE' | translate
                    }}</label>
                <twc-date-picker [maxDate]="today">
                    <input twcInputDate formControlName="projectCaptureDate">
                </twc-date-picker>
            </div>
        </div>
    </form>
</div>